window.Shutter = (function() {
	var callbacks = {
			/**
			 * 	Invoked with two arguments:
			 *  (shutterData, alpacaInstance)
			 *
			 *  this context is the Shutter object
			 *  
			 * 	shutterData:
			 * 		object storing the current shutter data
			 *  alpacaInstance:
			 * 		an instance of the alpaca js object used to power the form.
			 *		unlikley to be used as everything is handled within the init of the 
			 *		plugin but passed as an argument just in case
			 */
			'change': [],
			/**
			 * 	Invoked with one argument:
			 *  (alpacaInstance)
			 *
			 *  this context is the Shutter object
			 *  
			 *  alpacaInstance:
			 * 		an instance of the alpaca js object used to power the form.
			 *		unlikley to be used as everything is handled within the init of the 
			 *		plugin but passed as an argument just in case
			 */
			'beforeSubmit': [],
		},
		alpacaInstance;

	return {
		setAlpacaInstance: function(alpaca) {
			alpacaInstance = alpaca;
		},

		getAlpacaInstance: function() {
			return alpacaInstance;
		},

		addCallback: function(type, cb) {
			if(callbacks[type]) {
				callbacks[type].push(cb);
			}
		},

		fireCallback: function(type, args) {
			if(callbacks[type]) {
				if(!args) {
					args = []
				}

				if(type == 'change' || type == 'beforeSubmit') {
					args.push(alpacaInstance);
				}

				_l.each(callbacks[type], function(callback) {
					callback.apply(this, args);
				});
			}
		}
	}
})();

$(document).ready(function() {

	var $shutterDesignForm = $("#shutter-design-form"),
		$window = $(window);

	if($shutterDesignForm.length) {

		var $quantity = $('#quantity'),
			$shutterDesignFormAttributeContainer = $('#shutter-design-product-attributes'),
			shutterDesignFormAttributesCreated = false,
			
			$shutterDesignPrice = $("#shutter-design-price"),
			$addItemForm = $('#add-item-form');



		var isBlind = false,
			$isblind = $('#shutterproduct-isblind');
		if($isblind.val() == '1') {
			isBlind = true;
		}

		// Example price is £159 per m2
		var pricePerSquareMeter = parseFloat($('#shutterproduct-price_per_m').val()),
			midRailFromEdgeMin = 200,
			midRailRequiredOver = 1900,
			midRailIsActuallyDivider = false,
			midRailDisabled = false,
			shutterStyles,
			shutterRanges,
			blindRanges,
			louvreSizes,
			panelConfigurations,
			tiltrodPositions,
			frameTypes,
			frameSides,
			paints,
			stains,
			hardwareMaterialse;

		window.shutterData = {};

		window.shutterData.shutterStyles = shutterStyles = {
			'cafe': {
				"name": 'Café'
			},
			'tier-on-tier': {
				"name": 'Tier on Tier'
			},
			'full-height': {
				"name": 'Full Height'
			},
			'bay-window': {
				"name": 'Bay Window'
			},
			'tracking-system': {
				"name": 'Tracking System'
			},
			'shaped-windows': {
				"name": 'Shaped Windows'
			}
		};

		window.shutterData.shutterRanges = shutterRanges = {
			'antigua-express': {
				"name": 'Antigua Express',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2400,
				"maxHeight": 2000,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 600,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-003"],
				"hinges": ["white"],
				"knobs": [],
				"panelConfigurationOverrides": {
					"3": ["LRR", "LLR"],
					"4": ["LLRR"]
				}
			},
			'antigua': {
				"name": 'Antigua',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2400,
				"maxHeight": 2500,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 600,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-006", "colour-032", "colour-063"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque"],
				"knobs": [],
				"panelConfigurationOverrides": {
					"3": ["LRR", "LLR"],
					"4": ["LLRR"]
				}
			},
			'bermuda': {
				"name": 'Bermuda',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2440,
				"maxHeight": 2500,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 610,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-009", "colour-032", "colour-049", "colour-053", "colour-080"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque"],
				"knobs": [],
				"panelConfigurationOverrides": {
					"3": ["LRR", "LLR"],
					"4": ["LLRR"]
				}
			}, 
			'cuba': {
				"name": 'Cuba',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 4400,
				"maxHeight": 3000,
				"maxPanels": 8,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-009", "colour-032", "colour-049", "colour-053", "colour-063", "colour-076", "colour-080"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque"],
				"knobs": [],
                "panelConfigurationOverrides": {
                    "3": ['LLL','LLR','LRR','RRR']
                }
			},
			'fiji': {
				"name": 'Fiji',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 4400,
				"maxHeight": 3000,
				"maxPanels": 8,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-007", "colour-009", "colour-012", "colour-019", "colour-032", "colour-049", "colour-053", "colour-063", "colour-066", "colour-076", "colour-080", "colour-600", "colour-601", "colour-602", "colour-611", "colour-612", "colour-613", "colour-614", "colour-615", "colour-617", "stain-108", "stain-109", "stain-110", "stain-204", "stain-211", "stain-212", "stain-215", "stain-219", "stain-220", "stain-221", "stain-227", "stain-229", "stain-230", "stain-233", "stain-237", "stain-862"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque", "black"],
                "knobs": [],
                "panelConfigurationOverrides": {
                    "3": ['LLL','LLR','LRR','RRR']
                }
			},
			'sumatra': {
				"name": 'Sumatra',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 4400,
				"maxHeight": 3000,
				"maxPanels": 8,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-007", "colour-008", "colour-009", "colour-011", "colour-012", "colour-013", "colour-014", "colour-016", "colour-019", "colour-030", "colour-032", "colour-048", "colour-049", "colour-051", "colour-053", "colour-064", "colour-065", "colour-066", "colour-067", "colour-068", "colour-069", "colour-070", "colour-071", "colour-072", "colour-080", "stain-108", "stain-109", "stain-110", "stain-114", "stain-202", "stain-204", "stain-205", "stain-211", "stain-212", "stain-214", "stain-215", "stain-219", "stain-220", "stain-221", "stain-227", "stain-229", "stain-230", "stain-232", "stain-237", "stain-862"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque", "black"],
				"knobs": []
			}, 
			'java': {
				"name": 'Java',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2200,
				"maxHeight": 3000,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": true,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-009", "colour-032", "colour-049", "colour-053", "colour-063", "colour-076", "colour-080"],
				"hinges": ["stainless-steel"],
				"knobs": [],
				"panelConfigurationOverrides": {
					"3": ["LRR", "LLR"],
					"4": ["LLRR"]
				}
			}, 
			'solid-shaker': {
				"name": 'Solid Shaker',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2200,
				"maxHeight": 2500,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": false,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-007", "colour-009", "colour-011", "colour-012", "colour-013", "colour-014", "colour-016", "colour-019", "colour-030", "colour-032", "colour-048", "colour-049", "colour-051", "colour-053", "colour-066", "colour-072", "colour-080", "stain-108", "stain-109", "stain-110", "stain-114", "stain-202", "stain-204", "stain-205", "stain-211", "stain-212", "stain-215", "stain-219", "stain-220", "stain-221", "stain-227", "stain-229", "stain-230", "stain-232", "stain-237", "stain-242", "stain-862"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque"],
                "knobs": ["brushed-nickel"],
                "panelConfigurationOverrides": {
                    "3": ['LLL','LLR','LRR','RRR']
                }
			}, 
			'solid-raised': {
				"name": 'Solid Raised',
				"minWidth": 250,
				"minHeight": 500,
				"maxWidth": 2200,
				"maxHeight": 2500,
				"maxPanels": 4,
				"minWidthPerPanel": 250,
				"maxWidthPerPanel": 550,
				"needsTiltrod": false,
				"colours": ["colour-001", "colour-002", "colour-003", "colour-004", "colour-006", "colour-007", "colour-009", "colour-011", "colour-012", "colour-013", "colour-014", "colour-016", "colour-019", "colour-030", "colour-032", "colour-048", "colour-049", "colour-051", "colour-053", "colour-066", "colour-072", "colour-080", "stain-108", "stain-109", "stain-110", "stain-114", "stain-202", "stain-204", "stain-205", "stain-211", "stain-212", "stain-215", "stain-219", "stain-220", "stain-221", "stain-227", "stain-229", "stain-230", "stain-232", "stain-237", "stain-242", "stain-862"],
				"hinges": ["bright-brass", "antique-brass", "brushed-nickel", "nickel", "pearl", "white", "bisque"],
                "knobs": ["brushed-nickel"],
                "panelConfigurationOverrides": {
                    "3": ['LLL','LLR','LRR','RRR']
                }
			}
		};

		window.shutterData.blindRanges = blindRanges = {
			"pure-wood": {
				"name": 'Pure Wood',
				"minWidth": 208,
				"minHeight": 250,
				"maxWidth": 2400,
				"maxHeight": 3000,
				"colours": ["colour-001", "colour-002", "colour-006", "colour-012", "colour-019", "colour-032", "colour-049", "colour-053", "colour-080", "stain-108", "stain-109", "stain-110", "stain-114", "stain-204", "stain-211", "stain-212", "stain-215", "stain-219", "stain-220", "stain-221", "stain-227", "stain-230", "stain-233", "stain-237", "stain-862"],
			}
		};

		window.shutterData.louvreSizes = louvreSizes = [
			'64mm',
			'76mm', 
			'89mm'
		];

		window.shutterData.panelConfigurations = panelConfigurations = {
			1: [
				'L',
				'R'
			],
			2: [
				'LL',
				'RR',
				'LR',
			],
			3: [
				'LLL',
				'LLR',
				'LRR',
			],
			4: [
				'LLLL',
				'RRRR',
				'LLRR',
				'LLLR',
				'LRRR',
			],
			5: [
				'LLLLR',
				'LRRRR',
				'LLLRR',
				'LLRRR'
			],
			6: [
				'LLLRRR',
				'LLLLRR',
				'LLRRRR'
			],
			7: [
				'LLLRRRR',
				'LLLLRRR'
			],
			8: [
				'LLLLRRRR'
			]
		};

		window.shutterData.tiltrodPositions = tiltrodPositions = {
			"central": {
				"name": "Central"
			},
			"offset": {
				"name": "Offset"
			},
			"hidden": {
				"name": "Hidden"
			}
		};

		window.shutterData.frameTypes = frameTypes = {
			"dont-know": {
				"name": "Don\'t Know",
				"image": false,
				"sortOrder": 0
			},
			"bull-nose-z": {
				"name": "Bull Nose Z",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/frame-bull-nose-z.png?v=105141810608091210301569501603",
				"sortOrder": 1
			},
			"camber-deco": {
				"name": "Camber Deco",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/frame-camber-deco.png?v=3200630528434597091569501602",
				"sortOrder": 2
			},
			"deep-plain-l": {
				"name": "Deep Plain L",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/frame-deep-plain-l.png?v=77055169251454944351569501594",
				"sortOrder": 4
			},
			"insert-l": {
				"name": "Insert L",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/frame-insert-l.png?v=60952171277082907641569501598",
				"sortOrder": 3
			}
		};

		window.shutterData.frameSides = frameSides = {
			"3-sides": {
				"name": "3 sides"
			},
			"4-sides": {
				"name": "4 sides"
			}
		};

		window.shutterData.paints = paints = {
		    "colour-001": {
		        "name": "Pure White",
		        "slug": "pure-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-pure-white-thumb.png?v=63778033471450746691499424728",
		        "colour": "#fcfcfc",
		        "shade": "light"
		    },
		    "colour-002": {
		        "name": "Extra White",
		        "slug": "extra-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-extra-white-thumb.png?v=171840844550574823031499424727",
		        "colour": "#fdfdfd",
		        "shade": "light"
		    },
		    "colour-003": {
		        "name": "Silk White",
		        "slug": "silk-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-silk-white-thumb.png?v=1880516370721263601499424729",
		        "colour": "#fffef9",
		        "shade": "light"
		    },
		    "colour-004": {
		        "name": "Bright White",
		        "slug": "bright-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-bright-white-thumb.png?v=21647345332069474821499424726",
		        "colour": "#f2eeeb",
		        "shade": "light"
		    },
		    "colour-006": {
		        "name": "Pearl",
		        "slug": "pearl",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-pearl-thumb.png?v=142512815869785107571499424728",
		        "colour": "#efece7",
			        "shade": "light"
		    },
		    "colour-007": {
		        "name": "Ivory Lace",
		        "slug": "ivory-lace",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-ivory-lace-thumb.png?v=92882923323338433451499424727",
		        "colour": "#f3f6e3",
			        "shade": "light"
		    },
		    "colour-008": {
		        "name": "Marshmallow",
		        "slug": "marshmallow",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-marshmallow-thumb.png?v=13406897583722622651499424727",
		        "colour": "#fef6f4",
			        "shade": "light"
		    },
		    "colour-009": {
		        "name": "Creamy",
		        "slug": "creamy",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-creamy-thumb.png?v=48298850627064086761499424727",
		        "colour": "#f2eadf",
			        "shade": "light"
		    },
		    "colour-011": {
		        "name": "Cameo",
		        "slug": "cameo",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-cameo-thumb.png?v=21099662902204038601499424726",
		        "colour": "#fcfcdd",
			        "shade": "light"
		    },
		    "colour-012": {
		        "name": "Crisp Linen",
		        "slug": "crisp-linen",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-crisp-linen-thumb.png?v=116076080784118784171499424727",
		        "colour": "#f7f5de",
			        "shade": "light"
		    },
		    "colour-013": {
		        "name": "Bisque",
		        "slug": "bisque",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-bisque-thumb.png?v=48568442267961750481499424726",
		        "colour": "#fbf5db",
			        "shade": "light"
		    },
		    "colour-014": {
		        "name": "Alabaster",
		        "slug": "alabaster",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-alabaster-thumb.png?v=143183061733187391421499424725",
		        "colour": "#fce7d2",
			        "shade": "light"
		    },
		    "colour-016": {
		        "name": "Butter",
		        "slug": "butter",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-butter-thumb.png?v=36311635992417478761499424726",
		        "colour": "#f4deb5",
			        "shade": "medium"
		    },
		    "colour-019": {
		        "name": "String",
		        "slug": "string",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-string-thumb.png?v=55605390461874408441499424729",
		        "colour": "#e6d2b7",
			        "shade": "medium"
		    },
            "colour-030": {
		        "name": "Moondust",
		        "slug": "moondust-030",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-moondust-030-thumb.jpg?v=166462811245029752011737978655",
		        "colour": "#93948e",
		        "shade": "medium"
		    },
		    "colour-032": {
		        "name": "Sea Mist",
		        "slug": "sea-mist",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-sea-mist-thumb.png?v=42983793819624741581499424729",
		        "colour": "#ded7cf",
			        "shade": "medium"
		    },
		    "colour-048": {
		        "name": "Chai",
		        "slug": "chai",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-chai-thumb.png?v=40993921808682579601499424726",
		        "colour": "#d8c68d",
			        "shade": "medium"
		    },
		    "colour-049": {
		        "name": "Stone Grey",
		        "slug": "stone-grey",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-stone-grey-thumb.png?v=141646699349033537721499424729",
		        "colour": "#d0c1b0",
			        "shade": "medium"
		    },
		    "colour-051": {
		        "name": "Brown Grey",
		        "slug": "brown-grey",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-brown-grey-thumb.png?v=48055779282125894021499424726",
		        "colour": "#4a3615",
			        "shade": "dark"
		    },
		    "colour-053": {
		        "name": "Clay",
		        "slug": "clay",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-clay-thumb.png?v=141976297625652772321499424727",
		        "colour": "#2b352c",
			        "shade": "dark"
		    },
			"colour-063": {
		        "name": "Decorator's White",
		        "slug": "decorator-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-decorator-white-thumb.jpg?v=105689926327253569911737978646",
		        "colour": "#eff0e9",
			        "shade": "light"
		    },
		    "colour-064": {
		        "name": "Wonston 203",
		        "slug": "wonston-203",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-wonston-203-thumb.png?v=92908602492334245681499424729",
		        "colour": "#faf6d1",
			        "shade": "medium"
		    },
		    "colour-065": {
		        "name": "Micheldever 208",
		        "slug": "micheldever-208",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-micheldever-208-thumb.png?v=176092489827341363271499424728",
		        "colour": "#e9e6bd",
			        "shade": "medium"
		    },
		    "colour-066": {
		        "name": "Winchester White 2010",
		        "slug": "winchester-white-2010",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-winchester-white-2010-thumb.png?v=90052502206492256261499424729",
		        "colour": "#f6f1db",
			        "shade": "medium"
		    },
		    "colour-067": {
		        "name": "Candover White 2012",
		        "slug": "candover-white-2012",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-candover-white-2012-thumb.png?v=160551916742297029911499424726",
		        "colour": "#efeac2",
			        "shade": "medium"
		    },
		    "colour-068": {
		        "name": "Popham 2013",
		        "slug": "popham-2013",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-popham-2013-thumb.png?v=22136712493050426331499424728",
		        "colour": "#f4e2bc",
			        "shade": "medium"
		    },
		    "colour-069": {
		        "name": "Worthy White 226",
		        "slug": "worthy-white-226",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-worthy-white-226-thumb.png?v=120702671750474723731499424730",
		        "colour": "#e7d7bd",
		        "shade": "medium"
		    },
		    "colour-070": {
		        "name": "Stockbridge White 201",
		        "slug": "stockbridge-white-201",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-stockbridge-white-201-thumb.png?v=100824646357808911971499424729",
		        "colour": "#e1d9c4",
		        "shade": "medium"
		    },
		    "colour-071": {
		        "name": "Barnes ",
		        "slug": "barnes",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-barnes-thumb.png?v=119427574309066424511499424725",
		        "colour": "#c2cf9a",
		        "shade": "medium"
		    },
		    "colour-072": {
		        "name": "Mattingley 267",
		        "slug": "mattingley-267",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-mattingley-267-thumb.png?v=134619174370139118071499424728",
		        "colour": "#b2a9a0",
		        "shade": "medium"
		    },
			"colour-076": {
		        "name": "Aura White",
		        "slug": "aura-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-aura-white-thumb.jpg?v=96763427961234807041737978630",
		        "colour": "#e7e6e2",
			        "shade": "light"
		    },
            "colour-080": {
		        "name": "Taupe Grey",
		        "slug": "taupe-grey-080",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-taupe-grey-080-thumb.jpg?v=3718458749164080801737978668",
		        "colour": "#a7a79d",
		        "shade": "medium"
		    },
			"colour-600": {
		        "name": "Polaris",
		        "slug": "polaris",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-polaris-thumb.jpg?v=103519687840445030161737978658",
		        "colour": "#e6e3de",
		        "shade": "light"
		    },
			"colour-601": {
		        "name": "Chalk White",
		        "slug": "chalk-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-chalk-white-thumb.jpg?v=57654778601956027601737978639",
		        "colour": "#d3ccc2",
		        "shade": "light"
		    },
			"colour-602": {
		        "name": "Cotswold White",
		        "slug": "cotswold-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-cotswold-white-thumb.jpg?v=154444130900088109741737978644",
		        "colour": "#d4d0c5",
		        "shade": "light"
		    },
			"colour-611": {
		        "name": "Dover White",
		        "slug": "dover-white",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-dover-white-thumb.jpg?v=87995003798695996501737978647",
		        "colour": "#e8e7e3",
		        "shade": "light"
		    },
			"colour-612": {
		        "name": "Summer Haze",
		        "slug": "summer-haze",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-summer-haze-thumb.jpg?v=121427572997358442171737978667",
		        "colour": "#f0ede6",
		        "shade": "light"
		    },
			"colour-613": {
		        "name": "Steam",
		        "slug": "steam",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-steam-thumb.jpg?v=179680732616523200041737978663",
		        "colour": "#e3dbd0",
		        "shade": "light"
		    },
			"colour-614": {
		        "name": "Harris",
		        "slug": "harris",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-harris-thumb.jpg?v=143906656537176534371737978649",
		        "colour": "#bcb0a4",
		        "shade": "medium"
		    },
			"colour-615": {
		        "name": "Calico",
		        "slug": "calico",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-calico-thumb.jpg?v=79937774928012315361737978636",
		        "colour": "#bfb6ad",
		        "shade": "medium"
		    },
			"colour-617": {
		        "name": "Platter",
		        "slug": "platter",
		        "type": "paint",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-paint-platter-thumb.jpg?v=4728151879365569991737978657",
		        "colour": "#9f9a94",
		        "shade": "medium"
		    },
		};

		window.shutterData.stains = stains = {
		    "stain-108": {
		        "name": "Rustic Grey",
		        "slug": "rustic-grey",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-rustic-grey-thumb.png?v=26562575731224892741499424736",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-rustic-grey.png?v=72191173196773895531499424750",
		        "shade": "dark"
		    },
		    "stain-109": {
		        "name": "Weathered Teak",
		        "slug": "weathered-teak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-weathered-teak-thumb.png?v=53912348366023189781499424736",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-weathered-teak.png?v=71068561004617826831499424751",
			        "shade": "dark"
		    },
		    "stain-110": {
		        "name": "Limed White",
		        "slug": "limed-white",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-limed-white-thumb.png?v=50367028757471614801499424733",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-limed-white.png?v=69631070584408883841499424750",
			        "shade": "medium"
		    },
		    "stain-114": {
		        "name": "Taupe",
		        "slug": "taupe",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-taupe-thumb.png?v=158740188839627774921499424736",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-taupe.png?v=138028202042282704121499424750",
			        "shade": "medium"
		    },
		    "stain-202": {
		        "name": "Golden Oak",
		        "slug": "golden-oak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-golden-oak-thumb.png?v=66416557164341625111499424731",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-golden-oak.png?v=138957410641645736111499424750",
			        "shade": "medium"
		    },
		    "stain-204": {
		        "name": "Oak Mantel",
		        "slug": "oak-mantel",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-oak-mantel-thumb.png?v=100226788014725123601499424734",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-oak-mantel.png?v=162111187350626156151499424750",
			        "shade": "medium"
		    },
		    "stain-205": {
		        "name": "Goldenrod",
		        "slug": "goldenrod",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-goldenrod-thumb.png?v=143341175287016054221499424732",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-goldenrod.png?v=86105108850758003231499424750",
			        "shade": "medium"
		    },
		    "stain-211": {
		        "name": "Cherry",
		        "slug": "cherry",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-cherry-thumb.png?v=115706331790131925241499424730",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-cherry.png?v=75615580046209967281499424749",
			        "shade": "dark"
		    },
		    "stain-212": {
		        "name": "Dark Teak",
		        "slug": "dark-teak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-dark-teak-thumb.png?v=104932848391972617241499424731",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-dark-teak.png?v=7397789652686506131499424749",
			        "shade": "dark"
		    },
		    "stain-214": {
		        "name": "Cocoa",
		        "slug": "cocoa",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-cocoa-thumb.png?v=120636052933845058101499424731",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-cocoa.png?v=157863218849850732931499424749",
			        "shade": "dark"
		    },
		    "stain-215": {
		        "name": "Cordovan",
		        "slug": "cordovan",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-cordovan-thumb.png?v=140489206312741923581499424731",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-cordovan.png?v=163030553598970364911499424749",
			        "shade": "dark"
		    },
		    "stain-219": {
		        "name": "Mahogany",
		        "slug": "mahogany",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-mahogany-thumb.png?v=39263248611116557791499424733",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-mahogany.png?v=181473559684908297571499424750",
			        "shade": "dark"
		    },
		    "stain-220": {
		        "name": "New Ebony",
		        "slug": "new-ebony",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-new-ebony-thumb.png?v=177895392868747807141499424734",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-new-ebony.png?v=19956384636323919111499424750",
			        "shade": "dark"
		    },
		    "stain-221": {
		        "name": "Black Walnut",
		        "slug": "black-walnut",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-black-walnut-thumb.png?v=143861294476183938221499424730",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-black-walnut.png?v=126241626211058035151499424749",
			        "shade": "dark"
		    },
		    "stain-227": {
		        "name": "Red Oak",
		        "slug": "red-oak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-red-oak-thumb.png?v=168838491877303089161499424735",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-red-oak.png?v=160282891564829078361499424750",
			        "shade": "dark"
		    },
		    "stain-229": {
		        "name": "Rich Walnut",
		        "slug": "rich-walnut",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-rich-walnut-thumb.png?v=21736271503827026981499424735",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-rich-walnut.png?v=177671499621721003071499424750",
			        "shade": "dark"
		    },
		    "stain-230": {
		        "name": "Old Teak",
		        "slug": "old-teak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-old-teak-thumb.png?v=59979489219844421291499424734",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-old-teak.png?v=142737439618904049341499424750",
			        "shade": "dark"
		    },
		    "stain-232": {
		        "name": "Red Mahogany",
		        "slug": "red-mahogany",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-red-mahogany-thumb.png?v=54469231661433136031499424734",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-red-mahogany.png?v=172033459339400982591499424750",
			        "shade": "dark"
		    },
			"stain-233": {
		        "name": "Dark Mahogany",
		        "slug": "dark-mahogany",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-dark-mahogany-thumb.jpg?v=147441064550050143191737978679",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-red-mahogany.png?v=172033459339400982591499424750",
			        "shade": "dark"
		    },
		    "stain-237": {
		        "name": "Wenge",
		        "slug": "wenge",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-wenge-thumb.png?v=114476801256072203231499424736",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-wenge.png?v=169893471628093436591499424751",
			        "shade": "dark"
		    },
		    "stain-242": {
		        "name": "Auburn",
		        "slug": "auburn",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-auburn-thumb.png?v=10958186842199910441499424730",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-auburn.png?v=45873532621948070901499424749",
			        "shade": "dark"
		    },
		    "stain-245": {
		        "name": "Rich Cherry",
		        "slug": "rich-cherry",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-rich-cherry-thumb.png?v=65828340633114058671499424735",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-rich-cherry.png?v=156396425240130355011499424750",
			        "shade": "dark"
		    },
		    "stain-862": {
		        "name": "French Oak",
		        "slug": "french-oak",
		        "type": "stain",
		        "image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/colour-stain-french-oak-thumb.png?v=148671011973901500171499424731",
		        "texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-stain-french-oak.png?v=176817174171643304841499424750",
			        "shade": "dark"
		    }
		};

		window.shutterData.hardwareMaterials = hardwareMaterials = {
			"bisque": {
				"name": "Bisque",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-bisque-thumb.png?v=145679159941427594881499424738",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-bisque.png?1047",
				"colour": "#f3f6f3"
			},
			"bright-brass": {
				"name": "Bright Brass",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-bright-brass-thumb.png?v=132678304817848090741499424739",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-bright-brass.png?1047",
				"colour": "#bcb76c"
			},
			"antique-brass": {
				"name": "Antique Brass",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-antique-brass-thumb.png?v=177926997045354220081499424738",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-antique-brass.png?1047",
				"colour": "#847e47"
			},
			"brushed-nickel": {
				"name": "Brushed Nickel",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-brushed-nickel-thumb.png?v=181989620049987165841499424739",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-brushed-nickel.png?1047",
				"colour": "#adaea3"
			},
			"nickel": {
				"name": "Nickel",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-nickel-thumb.png?v=3863869281597323611499424739",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-nickel.png?1047",
				"colour": "#afb2a6"
			},
			"pearl": {
				"name": "Pearl",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-pearl-thumb.png?v=182837318202369317091499424739",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-pearl.png?1047",
				"colour": "#f1efee"
			},
			"white": {
				"name": "White",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-white-thumb.png?v=38979041709998733601499424740",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-white.png?1047",
				"colour": "#f3f6f3"
			},
			"stainless-steel": {
				"name": "Stainless Steel",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-stainless-steel-thumb.png?v=183169802936630951581499424739",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-stainless-steel.png?1047",
				"colour": "#6b6c67"
			},
          	"black": {
				"name": "Black",
				"image": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/hardware-black-thumb.png?v=96959523514511211701499424738",
				"texture": "//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/texture-hardware-stainless-steel.png?1047",
				"colour": "#000000"
			}
		};

		Handlebars.registerHelper('colourImage', function(colourId) {
			if(paints[colourId]) {
				return paints[colourId].image;
			} else if (stains[colourId]) {
				return stains[colourId].image;
			}
		});

		Handlebars.registerHelper('colourName', function(colourId) {
			if(paints[colourId]) {
				return paints[colourId].name;
			} else if (stains[colourId]) {
				return stains[colourId].name;
			}
		});

		Handlebars.registerHelper('hardwareImage', function(hardwareId) {
			if(hardwareMaterials[hardwareId]) {
				return hardwareMaterials[hardwareId].image;
			}
		});

		Handlebars.registerHelper('hardwareName', function(hardwareId) {
			if(hardwareMaterials[hardwareId]) {
				return hardwareMaterials[hardwareId].name;
			}
		});

		Alpaca.registerView({
			"id": "shutter-radio-shuttercolour",
			"parent": "bootstrap-create",
			"templates": {
			    "control-radio": $('#template-radio-shuttercolour').html()
			}
		});

		Alpaca.registerView({
			"id": "shutter-radio-hardware",
			"parent": "bootstrap-create",
			"templates": {
			    "control-radio": $('#template-radio-hardware').html()
			}
		});

		Alpaca.registerView({
			"id": "shutter-object-step",
			"parent": "bootstrap-create",
			"templates": {
			    "container-object": $('#template-object-step').html()
			}
		});

		Alpaca.registerView({
			"id": "shutter-container",
			"parent": "bootstrap-create",
			"templates": {
			    "container": $('#template-container').html(),
			    "container-object": $('#template-object-step').html(),
			    "control": $("#template-control").html()
			}
		});
		    
	var $shutterDesignForm = $("#shutter-design-form"),
		$shutterDesignSummary = $("#shutter-design-summary"),
		$shutterDesignPrice = $("#shutter-design-price");

    var alpacaShutterObject = {
	    	"view": {
		        "parent": "bootstrap-create",
		        "displayReadonly": true
		    },

	        "schema": {
	            "type":"object",
	            "properties": {
	            	"id": {
	            		"type": "integer"
	            	},
	            	"quantity": {
	            		"type": "integer",
	            		"default": 1
	            	},
	            	"summary": {
	            		"type": "string"
	            	},
	            	"timestamp": {
	            		"type": "integer",
	            		"default": Date.now('u')
	            	},
	            	"blind": {
	            		"type": "object",
	            		"properties": {
	            			"is_blind": {
	            				"type": "boolean",
	            				"readonly": true
	            			}
	            		}
	            	},
	            	"shutter": {
	            		"type": "object",
	            		"properties": {
	            			"style": {
	            				"type": "string", 
	            				"enum": _l.keys(shutterStyles),
	            				"readonly": true
	            			},
	        				"range": {
	        					"type": "string",
	        					"enum": _l.keys(shutterRanges),
	        					"readonly": true
	        				},
	            		},
	            	},
	                "dimensions": {
	                    "type": "object",
	                    "properties": {
	                    	"width": {
	                    		"type": "integer",
	                    		"required": true,
	                            "default": jQuery.QueryString.width ? jQuery.QueryString.width : 500
	                    	},
	                    	"height": {
	                    		"type": "integer",
	                    		"required": true,
	                    		"default": jQuery.QueryString.height ? jQuery.QueryString.height : 500
	                    	},
	                    	"area": {
	                    		"type": "integer"
	                    	}
	                    },
	                },
	                "panels-louvres": {
	                	"type": "object",
	                	"properties": {
	                		"number-of-panels": {
	                			"type": "integer",
	                			"enum": [],
	                			"required": true
	                		},
	                		"panel-configuration": {
	                			"type": "string",
	                			"enum": [],
	                			"required": true
	                		},
	                		"mid-rail": {
	                			"type": "boolean"
	                		},
	                		"mid-rail-height": {
	                			"type": "integer",
	                			"minimum": midRailFromEdgeMin,
	                			"maximum": midRailFromEdgeMin * 2,
	                		},
	                		"mid-rail-is-actually-divider": {
	                			"type": "boolean"
	                		},
	                		"louvre-size": {
	                			"type": "string",
	                			"required": true,
	                			"enum": louvreSizes
	                		},
	                		"tiltrod-position": {
	                			"type": "string",
	                			"enum": _l.keys(tiltrodPositions)
	                		}
	                	},
	                },
	                "colours-finishes": {
	                	"type": "object",
	                	"lastStep": !isBlind ? false : true,
	                	"properties": {
	                		"paint": {
	                			"type": "string",
	                			"enum": []
	                		},
	                		"stain": {
	                			"type": "string",
	                			"enum": []
	                		},
	                		"hinge": {
	                			"type": "string",
	                			"enum": []
	                		},
	                		"knob": {
	                			"type": "string",
	                			"enum": []
	                		}
	                	}
	                },
	                "frame": {
	                	"type": "object",
	                	"lastStep": !isBlind ? true : false,
	                	"properties": {
	                		"frame-type": {
	                			"type": "string",
	                			"enum": _l.map(
                                			_l.sortBy(
                                              	_l.map(
                                                  	frameTypes, 
                                                  	function (val, key) { val.key = key; return val; }
                                                ), 
                                            	'sortOrder'
                                            ), 
                                  			function (val) { return val.key; }
                                		) /*_l.keys(frameTypes)*/,
	                			"required": true
	                		},
	                		"number-of-frame-sides": {
	                			"type": "string",
	                			"enum": _l.keys(frameSides),
	                			"required": true
	                		}
	                	}
	                }
	            },
	        },

	        "data": {
	        	"blind": {
	        		"is_blind": false,
	        	},
				"shutter": {
	    			"style": $('#shutterproduct-style').val(),
	    			"range": $('#shutterproduct-range').val()
	    		}
			},

	        "options": {
	        	"form": {
	        		"attributes": {
	        			"action": "/cart/add.js",
	        			"method": "post"
	        		},
	        		"buttons": {
	        			"submit": {
	        				"label": "Add my Design to Cart",
	        				"styles": "btn-primary btn-lg",
	        				"click": function() {
	        					Shutter.fireCallback('beforeSubmit');

	        					this.refreshValidationState(true);
		                        if (!this.isValid(true)) {
		                            this.focus();
		                            return;
		                        } else {
		                        	$.ajax({
		                        		"type": "POST",
		                        		url: $addItemForm.attr("action"),
		                        		"dataType": "json",
		                        		data: $addItemForm.serialize(),
		                        		success: function(data) {
		                        			window.location.href = "/cart";
		                        		}
		                        	});
		                        }
	        				}
	        			}
	        		}
	        	},

	        	"fields": {
	        		"id": {
	        			"hidden": true
	        		},
	        		"quantity": {
	        			"hidden": true
	        		},
	        		"summary": {
	        			"hidden": true
	        		},
	        		"timestamp": {
	        			"hidden": true
	        		},
	        		"blind": {
	        			"hidden": true
	        		},
	        		"shutter": {
	        			"hidden": true,
	        			"fields": {
	        				"style": {
	        					"optionLabels": _l.map(shutterStyles, function(style) { return style.name }),
	        					"removeDefaultNone": true,
	        				},
	        				"range": {
	        					"optionLabels": _l.map(shutterRanges, function(range) { return range.name }),
	        					"removeDefaultNone": true,
	        				} 
	        			}
	        		},
	        		"dimensions": {
	        			"label": "Dimensions",
	        			"view": "shutter-container",
	        			"fields": {
	        				"width": {
	        					"label": "Width",
	        					"numericEntry": true,
	        					"focus": true,"help": true
	        				},
	        				"height": {
	        					"label": "Height",
	        					"numericEntry": true
	        				},
	        				"area": {
	        					"label": "Area",
	        					"readonly": true
	        				}
	        			}
	        		},
	        		"panels-louvres": {
	        			"label": "Panels &amp; Louvres",
	        			"view": "shutter-container",
	        			"fields": {
	        				"number-of-panels": {
	        					"label": "Number of Panels",
	        					"type": "select",
	        					"noneLabel": "Select a number",
	        					"removeDefaultNone": false,"help": true
	        				},
	        				"panel-configuration": {
	        					"label": "Panel Configuration", 
	        					"type": "radio",
	        					"optionLabels": panelConfigurations[0],
	        					"removeDefaultNone": true,
	        					"hidden": true,
	        					"vertical": false,"help": true
	        				},
	        				"mid-rail": {
	        					"label": "Mid Rail?", 
	        					"type": "checkbox","help": true
	        				},
	        				"mid-rail-height": {
	        					"label": "Mid Rail Height",
	                			"helpers": ["Distance is from the bottom"],"help": true
	        				},
	        				"mid-rail-is-actually-divider": {
	        					"type": "hidden"
	        				},
	        				"louvre-size": {
	        					"label": "Louvre Size",
	        					// "view": "shutter-radio",
	        					"fieldClass": "btn-group",
	        					"removeDefaultNone": true,
	        					"vertical": false,"help": true
	        				},
	        				"tiltrod-position": {
	        					"label": "Tiltrod Position",
	        					"optionLabels": _l.map(tiltrodPositions, function(position) { return position.name }),
	        					"removeDefaultNone": true,
	        					"vertical": false,"help": true
	        				}
	        			},
	        		},
	        		"colours-finishes": {
	        			"label": "Colours & Finishes",
	        			"view": "shutter-container",
	        			"helpers": ["Please note image / colours shown are for visual reference only and not an exact representation as colours can vary on different screens. Colour sample chips are available on request - please call 0207 751 0937"],
	        			"fields": {
	        				"paint": {
	        					"label": "Paint Colours",
	        					"type": "radio",
	        					"view": "shutter-radio-shuttercolour"
	        				},
	        				"stain": {
	        					"label": "Stain Finishes",
	        					"type": "radio",
	        					"view": "shutter-radio-shuttercolour"
	        				},
	        				"hinge": {
	        					"label": "Hinges",
	        					"type": "radio",
	        					"view": "shutter-radio-hardware",
	        					"removeDefaultNone": true
	        				},
	        				"knob": {
	        					"label": "Knobs",
	        					"type": "radio",
	        					"view": "shutter-radio-hardware",
	        					"removeDefaultNone": true
	        				}
	        			}
	        		},
	        		"frame": {
	        			"label": "Frame",
	        			"view": "shutter-container",
	        			"fields": {
	        				"frame-type": {
	        					"type": "radio",
	        					"label": "Frame Type",
	        					"optionLabels": _l.map(_l.sortBy(frameTypes, 'sortOrder'), function(frameType) { return frameType.name }),
	        					"sort": function (a, b) {
	        						return frameTypes[a.value].sortOrder > frameTypes[b.value].sortOrder;
	        					},
	        					"removeDefaultNone": true,"help": true
	        				},
	        				"number-of-frame-sides": {
	        					"type": "select",
	        					"label": "Number of Frame Sides",
	        					"optionLabels": _l.map(frameSides, function(side) { return side.name }),
	        					"removeDefaultNone": true
	        				}
	        			}
	        		}
	        	}
	        },

	        
	        "postRender": function(control) {

	        	Shutter.setAlpacaInstance(control);

	        	// ==============================================
	    		//
	    		//    Handle steps
	    		//
	    		// ==============================================
	    		var steps = _l.keys(control.schema.properties),
	    			$allStepEditButtons = $(".step-edit");

	    		$(".btn-next").on("click", function(e) {
	    			var $this = $(this),
	    				thisStep = $this.data('step'),
	    				stepNumber = _l.indexOf(steps, thisStep),
	    				nextStep = false;

    				updateTimestamp();

	    			// Check if there are any steps left, nextStep will be left as false if not
					if(steps.length >= stepNumber + 1) {
						nextStep = steps[stepNumber + 1]
					}

					// Validate each field in this step before allowing the user to move on to the next step...
	    			// ... and find any currently invalid fields, also display their errors (if they not shown already)
	    			var allValid = _l.every(control.getControlByPath(thisStep).children, function(childControl) {
							if(!childControl.validate() && childControl.isVisible()) {
								childControl.refreshValidationState();
								return false;
							}
							return true;
						});

					if(!allValid) {
						
					} else {
						if(nextStep) {
							// If there were more steps and all validation for this step has passed, 
							// collapse this step and uncollapse the next
							var $toCollapse = $this.parents(".alpaca-container.collapse").first(),
								$toUncollapse = $(".alpaca-container-item[data-alpaca-container-item-name='" + nextStep + "']").find(".collapse");
							$toUncollapse.collapse('show');
							$toCollapse.collapse('hide');
							// Show all the previous edit buttons
							$toCollapse.parents(".alpaca-container-item").find(".step-edit").show();
							$window.scrollTo($shutterDesignForm, 200, { "offset": { "top": -160 } });
						} else {
							// That was the last step so now proceed to submitting the form
							// submitForm();
						}
					}
	    		});

	    		$allStepEditButtons.on("click", function(e) {
	    			var $this = $(this),
	    				$toCollapse = $(".collapse.in"),
	    				$toUncollapse = $this.parents(".alpaca-container-item").find(".collapse");

					if($toCollapse.length == 1) {
						$toCollapse.collapse("hide");
	    				$toUncollapse.collapse("show");
	    			}

	    			$allStepEditButtons.hide();

	    			$toUncollapse.parents(".alpaca-container-item").first().prevAll().find(".step-edit").show();
	    			$window.scrollTo($shutterDesignForm, 200, { "offset": { "top": -160 } });
	    		});

	    		// Hide all edit step buttons
	    		$allStepEditButtons.hide();

	        	// Remove bootstrap collapse classes added by Alpaca
	        	$(".collapse")
	        		.removeClass("in")
	        		.find("[data-alpaca-container-item-name='dimensions'] .alpaca-container").first()
	        			.addClass("in");
				$(".alpaca-top > .alpaca-container").removeClass("collapse");
	        	// Remove default Alpaca collapsible behaviour
	        	var $collapsibleButtons = $(".alpaca-container-label [data-toggle='collapse']");
	        	$collapsibleButtons.attr("data-target", null);
	        	$collapsibleButtons.off("mouseover");

	        	var idControl = control.getControlByPath("id"),
	        		timestampControl = control.getControlByPath("timestamp"),
	        		quantityControl = control.getControlByPath("quantity"),
	        		summaryControl = control.getControlByPath("summary"),
	        		blindIsBlindControl = control.getControlByPath("blind/is_blind"),
	        		dimensionWidthControl = control.getControlByPath("dimensions/width"),
	        		dimensionHeightControl = control.getControlByPath("dimensions/height"),
	        		dimensionAreaControl = control.getControlByPath("dimensions/area"),
	        		dimensionControls = [dimensionWidthControl, dimensionHeightControl],
	        		pricewatchControls = [dimensionWidthControl, dimensionHeightControl],
	        		coloursFinishesPaintControl = control.getControlByPath("colours-finishes/paint"),
	    			coloursFinishesStainControl = control.getControlByPath("colours-finishes/stain");

        		if(isBlind) {
    				blindIsBlindControl.setValue(true);
    			} else {
    				pricewatchControls.push(control.getControlByPath("panels-louvres/tiltrod-position"));
    			}

    			idControl.setValue($('#product-id').val());

    			var calculatePrice = function(widthMM, heightMM, multiplier) {
    				if(!multiplier) {
    					multiplier = 1;
    				}
					return (((pricePerSquareMeter)*((widthMM/1000)*(heightMM/1000))) * multiplier).toFixed(2);
				};

				var loadColoursControlsValues = function(selectedData) {
					// Add paints
	    			var rangePaints = _l.reject(selectedData.colours, function(id) { 
							return id.startsWith('stain');
						});
					
					coloursFinishesPaintControl.schema.enum = rangePaints;
					if(coloursFinishesPaintControl.schema.enum.length > 0) {
						coloursFinishesPaintControl.schema.required = true;
						coloursFinishesPaintControl.setValue('');
					}
					coloursFinishesPaintControl.refresh();
					if(coloursFinishesPaintControl.schema.enum.length == 0) {
						coloursFinishesPaintControl.hide();
					}

					// Add stains
					var rangeStains = _l.reject(selectedData.colours, function(id) { 
							return id.startsWith('colour');
						});

				 	coloursFinishesStainControl.schema.enum = rangeStains;
				 	if(coloursFinishesStainControl.schema.enum.length > 0) {
						coloursFinishesStainControl.schema.required = true;
					}
				 	coloursFinishesStainControl.refresh();
				 	if(coloursFinishesStainControl.schema.enum.length == 0) {
						coloursFinishesStainControl.hide();
					}
				}

				// ==============================================
	        	//
	        	//    Area control calcuation
	        	//
	        	// ==============================================

	        	// Function to be called when dimensions are changed
	    		var pricewatchControlsChangedValue = function(value) {
	    			var area = 0,
	    				price = 0;
	    			if(_l.isNaN(dimensionWidthControl.getValue()) || _l.isNaN(dimensionHeightControl.getValue())) {
	    				// If neither of the dimensions were valid numbers, default to 0
	    				dimensionAreaControl.setValue(area);
	    			} else {
	    				// If the dimensions were valid numbers, multiply them to get the area, setting the value
	    				// of the area field
	    				area = dimensionWidthControl.getValue() * dimensionHeightControl.getValue()
	    				dimensionAreaControl.setValue(area);
	    			}
	    			dimensionWidthControl.refreshValidationState();
	    			dimensionHeightControl.refreshValidationState();
	    			var width = dimensionWidthControl.getValue(),
    					height = dimensionHeightControl.getValue();

					if(isBlind) {
	    				price = calculatePrice(dimensionWidthControl.getValue(), dimensionHeightControl.getValue());
	    			} else {
	    				var panelsLouvresTiltrodPositionControl = control.getControlByPath("panels-louvres/tiltrod-position");
	    				if(panelsLouvresTiltrodPositionControl && panelsLouvresTiltrodPositionControl.getValue() == 'hidden') {
	    					price = calculatePrice(dimensionWidthControl.getValue(), dimensionHeightControl.getValue(), 1.1);
	    				} else {
	    					price = calculatePrice(dimensionWidthControl.getValue(), dimensionHeightControl.getValue());
	    				}
	    			}
	    			$shutterDesignPrice.text("Price: £" + price);
					quantityControl.setValue(price * 100);
	    		}
	    		pricewatchControlsChangedValue();

	    		// Listen for changes to dimensions
	    		_l.each(pricewatchControls, function(pricewatchControl) {
	    			pricewatchControl.subscribe(pricewatchControl, pricewatchControlsChangedValue);
	    		});

	        	if(isBlind) {
	        		loadColoursControlsValues(blindRanges['pure-wood']);
	        	} else {
	        		var shutterStyleControl = control.getControlByPath("shutter/style"),
		    			shutterRangeControl = control.getControlByPath("shutter/range"),
	        			selectedStyle = shutterStyleControl.getValue(),
	    				selectedStyleData = shutterStyles[selectedStyle],
	    				selectedRange = shutterRangeControl.getValue(),
	    				selectedRangeData = shutterRanges[selectedRange],
		    			shutterControls = [shutterStyleControl, shutterRangeControl],
	    			panelsLouvresNumberOfPanelsControl = control.getControlByPath("panels-louvres/number-of-panels"),
	    			panelsLouvresTiltrodPositionControl = control.getControlByPath("panels-louvres/tiltrod-position"),
	    			panelConfigurationControl = control.getControlByPath("panels-louvres/panel-configuration"),
	    			panelsLouvresMidRailIsActuallyDivider = control.getControlByPath("panels-louvres/mid-rail-is-actually-divider"),
	    			panelslouvresMidrailControl = control.getControlByPath("panels-louvres/mid-rail"),
					panelslouvresMidrailheightControl = control.getControlByPath("panels-louvres/mid-rail-height"),
					panelslouvresLouvreSizeControl = control.getControlByPath("panels-louvres/louvre-size"),
	    			coloursFinshesHingeControl = control.getControlByPath("colours-finishes/hinge"),
	    			coloursFinshesKnobControl = control.getControlByPath("colours-finishes/knob");

					// ==============================================
		    		//
		    		//    Style & range schema dependency
		    		//
		    		// ==============================================

					// Function to be called when a shutter type is chosen
					var loadShutterControlsValues = function() {
		    			// Find data for the current range, as they need to affect some minimums and maximumns
		    			var selectedStyle = shutterStyleControl.getValue(),
		    				selectedStyleData = shutterStyles[selectedStyle],
		    				selectedRange = shutterRangeControl.getValue(),
		    				selectedRangeData = shutterRanges[selectedRange];

		    			// Handle style specific special cases
		    			if(selectedStyle == 'tier-on-tier') {
		    				midRailIsActuallyDivider = true;
		    				panelsLouvresMidRailIsActuallyDivider.setValue(true);
		    				panelslouvresMidrailControl.setValue(true);
		    				panelslouvresMidrailControl.options.hidden = true;
		    				panelslouvresMidrailControl.hide();
		    				panelslouvresMidrailheightControl.options.label = "Split Height";
		    				panelslouvresMidrailheightControl.show();
		    			} else if(selectedStyle == 'cafe') {
		    				midRailDisabled = true;
		    				panelslouvresMidrailControl.options.hidden = true;
		    				panelslouvresMidrailControl.hide();
		    			}

                        console.log(selectedRange)

		    			// Handle range specific special cases
		    			if(selectedRange == 'solid-raised' || selectedRange == 'solid-shaker') {
					      
		    				panelslouvresLouvreSizeControl.options.hidden = true;
		    				panelslouvresLouvreSizeControl.hide();
		    			}

		    			// Set new minimum and maximum
		    			dimensionWidthControl.schema.minimum = selectedRangeData.minWidth;
		    			dimensionWidthControl.schema.maximum = selectedRangeData.maxWidth;
		    			// Add a helper message to show the user min/max values
		    			
		    			var widthHelperTemplate = Handlebars.compile("Minimum: {{min}}mm. Maximum: {{max}}mm."),
		    				widthHelperMessage = widthHelperTemplate({ "min": selectedRangeData.minWidth, "max": selectedRangeData.maxWidth });
	    				
		    			dimensionWidthControl.options.helpers = [widthHelperMessage];
		    			// Refresh the field to show the helper
		    			dimensionWidthControl.refresh();
		    			// Force revalidation of the field
		    			dimensionWidthControl.refreshValidationState();

		    			// Set new minimum and maximum
		    			dimensionHeightControl.schema.minimum = selectedRangeData.minHeight;
		    			dimensionHeightControl.schema.maximum = selectedRangeData.maxHeight;
		    			// Add a helper message to show the user min/max values
		    			
		    			var heightHelperTemplate = Handlebars.compile("Minimum: {{min}}mm. Maximum: {{max}}mm."),
		    				heightHelperMessage = heightHelperTemplate({ "min": selectedRangeData.minHeight, "max": selectedRangeData.maxHeight });
	    				
		    			dimensionHeightControl.options.helpers = [heightHelperMessage];
		    			// Refresh the field to show the helper
		    			dimensionHeightControl.refresh();
		    			// Force revalidation of the field
		    			dimensionHeightControl.refreshValidationState();

		    			// Tilt rod required or not?
						if(selectedRangeData.needsTiltrod) {
							panelsLouvresTiltrodPositionControl.schema.required = true;
							panelsLouvresTiltrodPositionControl.refresh();
						} else {
							panelsLouvresTiltrodPositionControl.hide();
						}

			    			loadColoursControlsValues(selectedRangeData);
		    			// Add paints
		    			var rangePaints = _l.reject(selectedRangeData.colours, function(id) {
								return id.startsWith('stain');
							});

						coloursFinishesPaintControl.schema.enum = rangePaints;
						if(coloursFinishesPaintControl.schema.enum.length > 0) {
							coloursFinishesPaintControl.schema.required = true;
							coloursFinishesPaintControl.setValue('');
						}
						coloursFinishesPaintControl.refresh();
						if(coloursFinishesPaintControl.schema.enum.length == 0) {
							coloursFinishesPaintControl.hide();
						}

						// Add stains
						var rangeStains = _l.reject(selectedRangeData.colours, function(id) {
								return id.startsWith('colour');
							});

					 	coloursFinishesStainControl.schema.enum = rangeStains;
					 	if(coloursFinishesStainControl.schema.enum.length > 0) {
							coloursFinishesStainControl.schema.required = true;
						}
					 	coloursFinishesStainControl.refresh();
					 	if(coloursFinishesStainControl.schema.enum.length == 0) {
							coloursFinishesStainControl.hide();
						}

						// Add hinges
						coloursFinshesHingeControl.schema.enum = selectedRangeData.hinges;
						if(coloursFinshesHingeControl.schema.enum.length > 0) {
							coloursFinshesHingeControl.schema.required = true;
						}
						coloursFinshesHingeControl.refresh();
						if(coloursFinshesHingeControl.schema.enum.length == 0) {
							coloursFinshesHingeControl.hide();
						}

						// Add knobs
						coloursFinshesKnobControl.schema.enum = selectedRangeData.knobs;
						if(coloursFinshesKnobControl.schema.enum.length > 0) {
							coloursFinshesHingeControl.schema.required = true;
						}
						coloursFinshesKnobControl.refresh();
						if(coloursFinshesKnobControl.schema.enum.length == 0) {
							coloursFinshesKnobControl.hide();
						}
		    		}
		    		loadShutterControlsValues();

		    		panelsLouvresNumberOfPanelsControl.on("change", function() {
		    			var numberOfPanels = panelsLouvresNumberOfPanelsControl.getValue();
		    			if(numberOfPanels) {
		    				var panelConfigurationEnum = panelConfigurations[numberOfPanels]
		    				if(selectedRangeData.panelConfigurationOverrides && selectedRangeData.panelConfigurationOverrides[numberOfPanels]) {
		    					panelConfigurationEnum = selectedRangeData.panelConfigurationOverrides[numberOfPanels];
		    				}
		    				panelConfigurationControl.schema.enum = panelConfigurationControl.options.optionLabels = panelConfigurationEnum;
		    				panelConfigurationControl.options.hidden = false;
		    				panelConfigurationControl.show();
		    			} else {
		    				panelConfigurationControl.schema.enum = [];
		    				panelConfigurationControl.hidden = true;
		    				panelConfigurationControl.hide();
		    			}
		    			// panelConfigurationControl.trigger("fieldupdate");
		    			panelConfigurationControl.refresh();
		    			renderPanelConfigurationImages();
		    		});

		    		// ==============================================
		    		//
		    		//    Draw panel configuration radios
		    		//
		    		// ==============================================

		    		var renderPanelConfigurationImages = function() {
	    				$(".alpaca-field[data-alpaca-field-name='panels-louvres_panel-configuration']").find(".radio > label").each(function() {
	    					var $this = $(this),
	    						configLetters = $this.text().trim(),
	    						config = configLetters.split(""),
	    						html = $this.find("input").prop("outerHTML");
							_l.each(config, function(configLetter, i) {
								if(i == 0 && configLetter == "L") {
									html += "<img src=\"//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/shutter-configuration-hinge.png?v=45451392467181127301499424748\" class=\"shutter-configuration-hinge shutter-configuration-hinge-l\">";
								}
								var extraClass = '';
								if(i != 0 && config[i - 1] != configLetter) {
									extraClass += "shutter-configuration-panel-seperate";
								}
								html += "<img src=\"//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/shutter-configuration-panel.png?v=38351973739624535991499424748\" class=\"shutter-configuration-panel shutter-configuration-panel-" + configLetter.toLowerCase() + " " + extraClass + "\">";
								if(i == (config.length - 1) && configLetter == "R") {
									html += "<img src=\"//the-shuttter-shop.myshopify.com/cdn/shop/t/2/assets/shutter-configuration-hinge.png?v=45451392467181127301499424748\" class=\"shutter-configuration-hinge shutter-configuration-hinge-r\">";
								}
							})
							html += "<span>" + configLetters + "</span>"
							$this.html(html);
	    				});
		    		};

		    		// ==============================================
		    		//
		    		//    Draw frame radios
		    		//
		    		// ==============================================

		    		var renderFrameTypeImages = function() {
		    			$(".alpaca-field[data-alpaca-field-name='frame_frame-type']").find(".radio > label").each(function() {
		    				var $this = $(this),
		    					$input = $this.find('input'),
		    					type = $input.val();
		    				if(type && frameTypes[type] && frameTypes[type].image) {
								$("<img src=\"" + frameTypes[type].image + "\">").insertAfter($input);
							}
		    			});
		    		}
		    		renderFrameTypeImages();

		    		// // Listen for changes on type drop downs
		    		// _l.each(shutterControls, function(shutterControl) {
		    		// 	// Listen for changes to the type dropdowns where we'll make some changes to the form
		    		// 	shutterControl.subscribe(shutterControl, shutterControlsChangedValue);
		    		// });

		    		// ==============================================
		    		//
		    		//    Number of panels adjustment
		    		//
		    		// ==============================================

		    		// Function to be called when width is changed
		    		var adjustNumberOfPanelsControl = function() {
		    			panelsLouvresNumberOfPanelsControl.setValue('');
		    			panelsLouvresNumberOfPanelsControl.trigger('change');

		    			var selectedRangeData = shutterRanges[shutterRangeControl.getValue()],
		    				width = parseInt(dimensionWidthControl.getValue()),
		    				panelNumberOptions;

		    			if(width >= selectedRangeData.minWidth) {
		    				panelNumberOptions = _l(selectedRangeData.maxPanels).times(function(n) {
		    					var checkPanelCount = n + 1;
		    					if(width.between(checkPanelCount * selectedRangeData.minWidthPerPanel, checkPanelCount * selectedRangeData.maxWidthPerPanel, true)) {
		    						return checkPanelCount.toString();
		    					} else {
		    						return 0;
		    					}
		    				}).value();
		    				panelNumberOptions = _l.without(panelNumberOptions, 0);
		    			} else {
		    				panelNumberOptions = [];
		    			}

		    			if(panelNumberOptions.length) {
		    				panelsLouvresNumberOfPanelsControl.schema.enum = panelNumberOptions;
		    				panelsLouvresNumberOfPanelsControl.options.optionLabels = panelNumberOptions;
		    				panelsLouvresNumberOfPanelsControl.options.helpers = [];
		    			} else {
		    				panelsLouvresNumberOfPanelsControl.schema.enum = [];
		    				panelsLouvresNumberOfPanelsControl.options.helpers = ["No panels are available for this size shutter"];
		    			}
		    			panelsLouvresNumberOfPanelsControl.refresh();
		    			// panelsLouvresNumberOfPanelsControl.displayMessage(panelsLouvresNumberOfPanelsControl.options.helper);
		    		}
		    		adjustNumberOfPanelsControl();

		    		dimensionWidthControl.subscribe(dimensionWidthControl, adjustNumberOfPanelsControl);

		    		// ==============================================
		    		//
		    		//    Number of panels change message
		    		//
		    		// ==============================================

		    		var feedbackPanelWidthControl = function() {
		    			
		    			var width = parseInt(dimensionWidthControl.getValue()),
		    				panelCount = parseInt(panelsLouvresNumberOfPanelsControl.getValue())
		    				panelWidthTemplate = Handlebars.compile("Panel width estimated at {{panelWidth}}mm");
	    				
		    			panelWidthMessage = panelWidthTemplate({ "panelWidth": Math.round(width / panelCount) });
		    			panelsLouvresNumberOfPanelsControl.options.helpers = [panelWidthMessage];
		    			panelsLouvresNumberOfPanelsControl.refresh();
		    		}

		    		panelsLouvresNumberOfPanelsControl.subscribe(panelsLouvresNumberOfPanelsControl, feedbackPanelWidthControl);

		    		// ==============================================
		    		//
		    		//    Mid rail height dependency
		    		//
		    		// ==============================================

		    		var midrailHeightDependency = function() {
		    			if(panelslouvresMidrailControl.getValue() == 1) {
		    				panelslouvresMidrailheightControl.schema.required = true;
		    			} else {
		    				panelslouvresMidrailheightControl.schema.required = false;
		    			}

		    			panelslouvresMidrailheightControl.refresh();

		    			if(panelslouvresMidrailControl.getValue() == 1) {
		    				panelslouvresMidrailheightControl.show();
		    			} else {
		    				panelslouvresMidrailheightControl.hide();
		    			}
		    		}
		    		midrailHeightDependency();

		    		panelslouvresMidrailControl.on("click", function() {
		    			if(panelslouvresMidrailControl.options.manuallySetValue) {
		    				panelslouvresMidrailControl.options.manuallySetValue = false
		    			} else {
		    				panelslouvresMidrailControl.options.manuallySetValue = true;
		    			}
		    		});

		    		panelslouvresMidrailControl.subscribe(panelslouvresMidrailControl, midrailHeightDependency);

		    		// ==============================================
		    		//
		    		//    Midrail height max/required calculation
		    		//
		    		// ==============================================

		    		var adjustMidrailheightControl = function() {
		    			if(midRailDisabled && selectedStyle !== 'tier-on-tier') {
		    				return;
		    			}

		    			var height = parseInt(dimensionHeightControl.getValue()),
		    				maximumMidrailHeight = height - midRailFromEdgeMin,
			    				midRailRequired = height > midRailRequiredOver || selectedStyle == 'tier-on-tier';

						if(midRailRequired) {
							panelslouvresMidrailheightControl.required = true;
							panelslouvresMidrailheightControl.show();
							panelslouvresMidrailControl.setValue(true);
							panelslouvresMidrailControl.options.readonly = true;
						} else {
							panelslouvresMidrailheightControl.required = false;
							panelslouvresMidrailControl.options.readonly = false;
							if(!panelslouvresMidrailControl.options.manuallySetValue) {
								panelslouvresMidrailControl.setValue(false);
							}
						}

		    			panelslouvresMidrailheightControl.schema.maximum = maximumMidrailHeight;
		    			
						var midrailHeightHelperTemplate = Handlebars.compile("Minimum: {{min}}mm. Maximum: {{max}}mm." + (midRailRequired ? " Required at given shutter height.": "")),
		    				midrailHeightHelperMessage = midrailHeightHelperTemplate({ "min": panelslouvresMidrailheightControl.schema.minimum, "max": panelslouvresMidrailheightControl.schema.maximum });
	    				
						if(panelslouvresMidrailheightControl.options.hasMinMaxMessage == true) {
							panelslouvresMidrailheightControl.options.helpers.pop();
						}

		    			panelslouvresMidrailheightControl.options.helpers.push(midrailHeightHelperMessage);
		    			panelslouvresMidrailheightControl.options.hasMinMaxMessage = true;

		    			var originalValue = panelslouvresMidrailheightControl.getValue();

		    			panelslouvresMidrailControl.refresh();
						panelslouvresMidrailheightControl.refresh();

		    			if(originalValue) {
		    				panelslouvresMidrailheightControl.unsubscribe(dimensionHeightControl, adjustMidrailheightControl);
		    				panelslouvresMidrailheightControl.setValue(originalValue);
		    				// $(panelslouvresMidrailheightControl.slider).slider('value', panelslouvresMidrailheightControl.getValue());
		    				panelslouvresMidrailheightControl.subscribe(dimensionHeightControl, adjustMidrailheightControl);
		    				panelslouvresMidrailheightControl.refreshValidationState();
		    			}

		    			if(midRailRequired) {
		    				panelslouvresMidrailheightControl.show();
		    			}

		    			midrailHeightDependency();
		    		}
		    		adjustMidrailheightControl();

		    		dimensionHeightControl.subscribe(dimensionHeightControl, adjustMidrailheightControl);
				}

	    		// ==============================================
	    		//
	    		//    Paint/stain/hardware selection
	    		//
	    		// ==============================================

	    		var textureImageRadioHighlightActive = function($removeActiveIn) {
					var $container = $(this.getControlEl()).parents('.alpaca-container-item');

					$container.find('.radio-texture-image-select.radio-texture-image-select-active')
						.removeClass('radio-texture-image-select-active');

					if($removeActiveIn && $removeActiveIn instanceof jQuery) {
						$removeActiveIn.find('.radio-texture-image-select.radio-texture-image-select-active')
							.removeClass('radio-texture-image-select-active');
					}

					$container
						.find('input:checked')
						.parents('.radio-texture-image-select')
							.addClass('radio-texture-image-select-active');
				}

				// var haveSetColourFinishPaintStain = false;

				var colourFinishPaintChosen = function(e) {
					unsubscribeColourFinishPaintStain();

					coloursFinishesPaintControl.schema.required = true;
					coloursFinishesPaintControl.refresh();

					coloursFinishesStainControl.schema.required = false;
					coloursFinishesStainControl.refresh();
					coloursFinishesStainControl.setValue('');
					if(coloursFinishesStainControl.schema.enum.length == 0) {
						coloursFinishesStainControl.hide();
					}

					textureImageRadioHighlightActive.apply(this, $('.alpaca-container-item[data-alpaca-container-item-name="colours-finishes_stain"]'));

					subscribeColourFinishPaintStain();
				}

				var colourFinishStainChosen = function(e) {
					unsubscribeColourFinishPaintStain();

					coloursFinishesStainControl.schema.required = true;
					coloursFinishesStainControl.refresh();

					coloursFinishesPaintControl.schema.required = false;
					coloursFinishesPaintControl.refresh();
					coloursFinishesPaintControl.setValue('');
					if(coloursFinishesPaintControl.schema.enum.length == 0) {
						coloursFinishesPaintControl.hide();
					}

					textureImageRadioHighlightActive.apply(this, $('.alpaca-container-item[data-alpaca-container-item-name="colours-finishes_paint"]'));

					subscribeColourFinishPaintStain();
				}

				var unsubscribeColourFinishPaintStain = function() {
					coloursFinishesPaintControl.unsubscribe(coloursFinishesPaintControl, colourFinishPaintChosen);
					coloursFinishesStainControl.unsubscribe(coloursFinishesStainControl, colourFinishStainChosen);
				}
				var subscribeColourFinishPaintStain = function() {
					coloursFinishesPaintControl.subscribe(coloursFinishesPaintControl, colourFinishPaintChosen);
					coloursFinishesStainControl.subscribe(coloursFinishesStainControl, colourFinishStainChosen);
				}
				subscribeColourFinishPaintStain();

				if(coloursFinshesHingeControl) {
				coloursFinshesHingeControl.subscribe(coloursFinshesHingeControl, textureImageRadioHighlightActive);
				}
				if(coloursFinshesKnobControl) {
				coloursFinshesKnobControl.subscribe(coloursFinshesKnobControl, textureImageRadioHighlightActive);
				}

				textureImageRadioHighlightActive.apply(coloursFinishesPaintControl);
				textureImageRadioHighlightActive.apply(coloursFinishesStainControl);
				if(coloursFinshesHingeControl) {
				textureImageRadioHighlightActive.apply(coloursFinshesHingeControl);
				}
				if(coloursFinshesKnobControl) {
				textureImageRadioHighlightActive.apply(coloursFinshesKnobControl);
				}

				// ==============================================
	    		//
	    		//    Fire event in Shutter pubsub object
	    		//
	    		// ==============================================

				// Function to be called when any field has possibly been changed
	    		var disableShutterChangeCallback = false,
	    			fireShutterChangeCallback = function() {
	    				if(!disableShutterChangeCallback) {
	    					Shutter.fireCallback('change', [control.getValue()]);
	    				}
	    			};
	    		fireShutterChangeCallback();

	    		// ==============================================
	    		//
	    		//    Summary change on any control change
	    		//
	    		// ==============================================

	    		var updateSummary = function () {
	    			var summaryParts = [],
	    				summary;
	    			summaryParts.push(dimensionHeightControl.getValue() + "mm x " + dimensionWidthControl.getValue() + " mm");
	    			if(coloursFinishesPaintControl.getValue()) {
	    				summaryParts.push($("#colours-finishes_paint").val() + " paint")
	    			}
	    			if(coloursFinishesStainControl.getValue()) {
	    				summaryParts.push($("#colours-finishes_stain").val() + " stain")
	    			}
	    			summary = summaryParts.join(". ") + ".";

	    			disableShutterChangeCallback = true;
	    			summaryControl.setValue(summary);
	    			disableShutterChangeCallback = false;
	    		}

	    		Shutter.addCallback('change', function(data) {
	    			updateSummary();
	    		});

	    		// ==============================================
	    		//
	    		//    Timestamp change on any control change
	    		//
	    		// ==============================================

	    		var updateTimestamp = function () {
	    			disableShutterChangeCallback = true;
	    			timestampControl.setValue(Date.now('u'));
	    			disableShutterChangeCallback = false;
	    		}

	    		Shutter.addCallback('change', function(data) {
	    			// We're setting a timestamp for the product so that the property will force a new
	    			// line item in the cart if we add two shutters that are configured *exactly* the same.
	    			// Shopify will split out cart items when properties differ but merge when identical
	    			updateTimestamp();
	    		});

	    		Shutter.addCallback('beforeSubmit', function(data) {
	    			// We're setting a timestamp for the product so that the property will force a new
	    			// line item in the cart if we add two shutters that are configured *exactly* the same.
	    			// Shopify will split out cart items when properties differ but merge when identical
	    			updateTimestamp();
	    		});

	    		// ==============================================
	    		//
	    		//    JSON output
	    		//
	    		// ==============================================

	    		function slenderizeObject (fatObject) {
	    		  	var _propertyIdentifiers = []
	    		  	var _slenderObject = {}

	    		  	function processNode (theNode, _propertyIdentifiers, _slenderObject) {
	    		    	theNode = theNode || {}
    		    		_propertyIdentifiers = _propertyIdentifiers || []
		    		      	var ret = _l(theNode)
		    		        .map(
		    		          	function (value, key) {
		    		            	var myKeys = _l.clone(_propertyIdentifiers),
		    		                	ret = {}
		    		            	myKeys.push(key)

		    		            	// if value is a string, number or boolean
		    		            	if (_l.isString(value) || _l.isNumber(value) || _l.isBoolean(value)) {
		    		              		// build a keyString to use as a property identifier
		    		              		var keyString = myKeys.join('.'),
		    		              			lastKey = '' + myKeys[myKeys.length],
		    		              			lastKeyHuman = lastKey.replace(/(\.|-)/g, ' ')
		    		              		// add a property with that identifier and childNode as the value to our return object
		    		              		ret[lastKeyHuman] = _slenderObject[keyString] = value
		    		            	} else {
		    		              		// Call processNode recursively if value isn't a leaf node type (string, number or boolean)
		    		              		processNode(value, myKeys, _slenderObject)
		    		              		ret = value
		    		            	}

		    		            	return ret;
		    		          	}, this
		    		        )
		    		        .value()

		    		    return ret
	    		  	}
    			  	processNode(fatObject, _propertyIdentifiers, _slenderObject)

	    		  	return _slenderObject
	    		}

	    		Shutter.addCallback('change', function(data) {
	    			var showData = slenderizeObject(data);

	    			$shutterDesignSummary.html( JsonHuman.format(showData, {
	    				showArrayIndex: false
	    			}) );
            $shutterDesignSummary.addClass("show");
	    			$shutterDesignSummary.find(".jh-key").each(function() {
	    				var $this = $(this),
	    					$val = $(this).next().find("span"),
	    					$parent = $this.parent(),
	    					removeKeys = ['id', 'quantity', 'summary', 'timestamp', 'blind.is_blind', 'panels-louvres.mid-rail-is-actually-divider'],
	    					mmKeys = ['dimensions.width', 'dimensions.height', 'dimensions.area', 'panels-louvres.mid-rail-height'],
	    					squaredKeys = ['dimensions.area'],
	    					removeSolidKeys = ['panels-louvres.louvre-size'],
	    					keyText = $this.text(),
	    					valueText = $val.text();


	    				// stains
	    				// hardwareMaterials

	    				// Replace text in the key and value to be human readable
    					if(_l.contains(removeKeys, keyText)) {
    						$parent.remove();
    					} else {
    						if(selectedRange == 'solid-shaker' || selectedRange == 'solid-raised') {
    							if(_l.contains(removeSolidKeys, keyText)) {
    								$parent.remove();
    							}
    						}

    						if(keyText == 'colours-finishes.paint') {
    							valueText = paints[valueText].name;
    						}

    						if(keyText == 'colours-finishes.stain') {
    							valueText = stains[valueText].name;
    						}

    						if(keyText == 'colours-finishes.hinge' || keyText == 'colours-finishes.knob') {
    							valueText = hardwareMaterials[valueText].name;
    						}

    						if(_l.contains(mmKeys, keyText)) {
    							valueText += 'mm';
							}

							if(_l.contains(squaredKeys, keyText)) {
    							valueText += '&#178;';
							}

							if(selectedStyle == 'tier-on-tier') {
    							if(keyText == 'panels-louvres.mid-rail') {
    								$parent.remove();
    							}
    							if(keyText == 'panels-louvres.mid-rail-height') {
    								keyText = 'split-height';
    							}
    						}

    						$this.html( keyText.replace(/^.*?\./,'')
    										.replace(/(-|_)/g, ' ') );
    						$val.html( valueText.replace(/^.*?\./,'')
    										.replace(/(-|_)/g, ' ')
    										.replace(/true/, 'Yes')
    										.replace(/false/, 'No') );

    					}
	    			})
	    		});


	    		function findChildrenControlsAndSubscribeJsonOutput(children) {
	    		    _l.each(children, function(childrensChildren){
	    		        if(childrensChildren.children && childrensChildren.children.length > 0){
	    		            findChildrenControlsAndSubscribeJsonOutput(childrensChildren.children);
	    		        } else {
	    		        	childrensChildren.subscribe(childrensChildren, fireShutterChangeCallback);
	    		        }
	    		    });
	    		};
	    		findChildrenControlsAndSubscribeJsonOutput(control.children);

	    		// ==============================================
	    		//
	    		//    Attribute output
	    		//
	    		// ==============================================

	    		function findChildrenControlsAndCreateHiddenAttribute(children) {
	    		    _l.each(children, function(childrensChildren){
	    		        if(childrensChildren.children && childrensChildren.children.length > 0){
	    		            findChildrenControlsAndCreateHiddenAttribute(childrensChildren.children);
	    		        } else {
	    		        	var attributePath = childrensChildren.path.replace(/^\//, ''),
	    		        		attributeName;
	    		        	if(attributePath != 'id' && attributePath != 'quantity') {
	    		        		attributeName = attributePath.replace(/\/(.*)$/g, '[$1]').replace(/(-|_)/g, ' '),
	    		        		attributeName = "properties[" + ( attributePath != 'summary' ? "_" : "" ) + attributeName + "]";
	    		        	} else {
	    		        		attributeName = attributePath;
	    		        	}
	    		        	$shutterDesignFormAttributeContainer.append("<input type=\"hidden\" id=\"" + childrensChildren.name + "\" name=\"" + attributeName + "\">");
	    		        }
	    		    });
	    		};
	    		if(!shutterDesignFormAttributesCreated) {
    				findChildrenControlsAndCreateHiddenAttribute(control.children);
    				shutterDesignFormAttributesCreated = true;
    				// $shutterDesignFormAttributeContainer.detach().appendTo($shutterDesignForm.find('form'));
    			}

    			Shutter.addCallback('change', function(data) {
    				if(shutterDesignFormAttributesCreated) {
    					_l.deepMapValues(data, function(value, pathArray) {
    						$shutterDesignFormAttributeContainer.find('#' + pathArray.join('_')).val(value);
    					});
    					var $paint = $shutterDesignFormAttributeContainer.find('#colours-finishes_paint'),
    						$stain = $shutterDesignFormAttributeContainer.find('#colours-finishes_stain');
						if(data['colours-finishes'] && data['colours-finishes']['paint']) {
							$paint.val( paints[data['colours-finishes']['paint']].name );
							$stain.val("");
						}
						if(data['colours-finishes'] && data['colours-finishes']['stain']) {
							$stain.val( stains[data['colours-finishes']['stain']].name );
							$paint.val("");
						}
						updateSummary();
	    			}
	    		});

				// ==============================================
	    		//
	    		//    Help content
	    		//
	    		// ==============================================

	    		$('#product').on('click', '.help-icon', function (e) {
	    			e.preventDefault();

	    			var $this = $(this),
    					$helpContent = $this.parents('.form-group').find('.help-content');

					if($helpContent.html().trim().length === 0) {
						$helpContent.html($('.help-content-provider[data-help-field="' + $this.data('help-field') + '"]').html());
					}

    				if($this.hasClass('active')) {
						$helpContent.slideUp();
	    				$this.removeClass('active');
    				} else {
    					$helpContent.slideDown();
	    				$this.addClass('active');
    				}
	    		});
	        }
		};

		if(isBlind) {
			delete alpacaShutterObject['schema']['properties']['shutter'];
			delete alpacaShutterObject['schema']['properties']['panels-louvres'];
			delete alpacaShutterObject['schema']['properties']['frame'];
			delete alpacaShutterObject['schema']['properties']['colours-finishes']['properties']['hinge'];
			delete alpacaShutterObject['schema']['properties']['colours-finishes']['properties']['knob'];
		}

		$shutterDesignForm.alpaca(alpacaShutterObject);

		ShutterDraw.init();
	}

});
